/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
  schemaTypes,
  dateFormat,
  fuelTypeMap,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
// import { getFuelPrices } from "./tripReport";

const isIdlingShowable = (item, props) => {
  let groups = props.groupTree.children.map((g) => g.name);
  let disable =
    ((window.userInfo || {}).SELF || {}).disableIdlingFromReports !== "DISABLE";
  if (groups.includes("KushalSSLLP")) return false;
  return disable;
};

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let locationbodyfrom = [];
  let locationbodyto = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let fueltype = _.get(vehicleMap, vehiclepath + ".vehiclemeta.fueltype");
    let model = vehicleMap[vehiclepath].vehicleModel
      ? vehicleMap[vehiclepath].vehicleModel.model
      : vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.model || ""
      : "";

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let duration =
        eachitem.tripduration != null
          ? parseFloat(eachitem.tripduration.toFixed(2))
          : null;
      let distance =
        eachitem.tripdistance != null
          ? parseFloat(eachitem.tripdistance.toFixed(2))
          : null;
      let fuelused =
        eachitem.fuelused != null && distance != null
          ? parseFloat(eachitem.fuelused.toFixed(2))
          : null;
      let mileage =
        fuelused != null && fuelused > 0 && distance != null
          ? parseFloat(distance / fuelused).toFixed(2)
          : null;
      let avgspeed = eachitem.avgspeed;
      let startodo =
        eachitem.startodo != null
          ? parseFloat(eachitem.startodo.toFixed(0))
          : null;
      let endodo =
        eachitem.endodo != null ? parseFloat(eachitem.endodo.toFixed(0)) : null;
      let tripscore = eachitem.tripscore;
      let startloc = eachitem.lat + "," + eachitem.lng;
      let endloc = eachitem.late + "," + eachitem.lnge;
      let idlingtime =
        eachitem.idlingtime != null
          ? parseFloat(
              (eachitem.idlingtime > 0
                ? eachitem.idlingtime / 1000 / 60
                : 0
              ).toFixed(2)
            )
          : null;
      let acidlingtime =
        eachitem.acidlingtime != null
          ? parseFloat(
              (eachitem.acidlingtime > 0
                ? eachitem.acidlingtime / 1000 / 60
                : 0
              ).toFixed(2)
            )
          : null;
      let EndLatLng = [eachitem.late, eachitem.lnge];
      let StartLatLng = [eachitem.lat, eachitem.lng];
      locationbodyfrom.push([eachitem.lat, eachitem.lng]);
      locationbodyto.push([eachitem.late, eachitem.lnge]);
      historyData.push({
        vehicleno,
        model,
        starttime,
        endtime,
        duration,
        distance,
        fuelused,
        mileage,
        avgspeed,
        idlingtime,
        acidlingtime,
        startodo,
        endodo,
        tripscore,
        fueltype,
        StartLatLng,
        EndLatLng,
        startloc,
        endloc,
      });
    }
  }

  callback(historyData);
  GeoCodeAPIs.getAddress(locationbodyfrom).then(
    (resp) => {
      for (let idx in historyData) {
        historyData[idx].startloc =
          (resp[idx] ? resp[idx][1] : "") +
          " (" +
          historyData[idx].startloc +
          ")";
      }
      callback(historyData);
      // if (historyData.length) getFuelPrices(resp, historyData, callback);
    },
    (resp) => {
      console.log(resp);
    }
  );
  GeoCodeAPIs.getAddress(locationbodyto).then(
    (resp) => {
      for (let idx in historyData) {
        historyData[idx].endloc =
          (resp[idx] ? resp[idx][1] : "") +
          " (" +
          historyData[idx].endloc +
          ")";
      }
      callback(historyData);
    },
    (resp) => {
      console.log(resp);
    }
  );
};

const getHistory = (schema, data, store) => {
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, (data) => {
        schema.finalData = data;
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: data.vehicle.map((item) => {
        return item.data.vehicleid;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
      tzoffset: momentTZ().utcOffset() * 60,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.getDailyReport(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    console.log("Please select atleast one vehicle");
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  if (schema.finalData) {
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.startloc = stripLoc(r.startloc);
        r.endloc = stripLoc(r.endloc);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        let headings = schema.content[0].head
          .filter((c) =>
            c.isShowable ? c.isShowable(data.vehicle, store) : true
          )
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }
    JSONToCSVConvertor(finalData, "DailyReport", false);
  }
};

const schema = {
  key: "daily_report_minimal",
  name: "Daily Report Minimal",
  finalData: null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Daily Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        // {key:'model', name:'Model'},
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        // {key:'duration', name:'Duration (min)'},
        { key: "distance", name: "Distance (km)" },
        // {key:'fuelused', name:'Fuelused (ltr)'},
        // {key:'mileage', name:'Mileage (kmpl)'},
        // {key:'cpk', name:'CPK (₹)'},
        // {key:'fuelprice', name:'Fuel Price (₹)'},
        // {key:'avgspeed', name:'Avg Speed (kmph)'},
        // {key:'idlingtime', name:'Idling Time (min)', isShowable: isIdlingShowable},
        // {key:'acidlingtime', name:'AC Idling (min)', isShowable: isIdlingShowable},
        // {key:'startodo', name:'Start Odo (km)'},
        // {key:'endodo', name:'End Odo (km)'},
        // // {key:'tripscore', name:'Trip Score'},
        // {key:'startloc', name:'Start Location', width:2,  onClick: (d, item)=>{ window.showInGoogleMaps(item.StartLatLng[0],item.StartLatLng[1])}},
        // {key:'endloc', name:'End Location', width:2,  onClick: (d, item)=>{ window.showInGoogleMaps(item.EndLatLng[0],item.EndLatLng[1])}},
      ],
    },
  ],
};
export default schema;
